import { useCallback, useEffect } from "react";

import { broadcast, broadcastChannels } from "@common/helpers/broadcast";

export function useSecondScreenHandler(callback, dependencies) {
	const subscriber = useCallback(callback, dependencies);

	useEffect(() => {
		broadcast.addEventListener(broadcastChannels.SecondScreenChange, subscriber);

		return () => broadcast.removeEventListener(broadcastChannels.SecondScreenChange, subscriber);
	}, dependencies);
}
